export default __webpack_public_path__ + "static/media/slider-typography-01.37b9357c.png";